export const ADD_REMINDER = 'ADD_REMINDER';

export const DELETE_REMINDER = 'DELETE_REMINDER';